import { render, staticRenderFns } from "./fi_favorites_bar.vue?vue&type=template&id=76b384b4&scoped=true&"
import script from "./fi_favorites_bar.vue?vue&type=script&lang=js&"
export * from "./fi_favorites_bar.vue?vue&type=script&lang=js&"
import style0 from "./fi_favorites_bar.vue?vue&type=style&index=0&id=76b384b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b384b4",
  null
  
)

export default component.exports